import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navigateToPOSSellers } from './utils/appNavigation';
import AllRoutes from './Router/router.jsx';
import { ConfigProvider } from 'antd';
import { initializeAuth, getCurrentUser } from './core/redux/auth.slice';
import { fetchActiveCompany } from './core/redux/company.slice';
import { isAuthenticationValid } from './core/services/auth.service';
import { socketService } from './core/services/socket.service'; 

const App = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);

  // Initialisation au démarrage de l'app (login OU refresh page)
  useEffect(() => {
    dispatch(initializeAuth());

    if (isAuthenticationValid()) {
      dispatch(getCurrentUser());
      dispatch(fetchActiveCompany());
    }
  }, [dispatch]);

  // Redirection seller vers POS
  useEffect(() => {
    if (user && user.roles?.includes('SELLER')) {
      navigateToPOSSellers();
    }
  }, [user]);

  //   NOUVEAU : Gestion du socket SignalR (connexion/déconnexion selon user)
  useEffect(() => {
    // user.id présent → utilisateur authentifié et chargé
    if (!user || !user.id) return;

    // Éviter les reconnexions inutiles
    if (socketService.isConnected()) return;

    // Pas de socket pour les sellers (ils utilisent la POS qui a son propre socket)
    if (user.roles?.includes('SELLER')) return;

    socketService.setUserContext(user);

    // Si l'user a un seul shop assigné, on rejoint sa room par défaut
    // Sinon on connecte sans shop (l'app pourra appeler joinShopRoom plus tard)
    const shopId = user?.shopIds?.length === 1 ? user.shopIds[0] : null;
    socketService.connect(shopId);

    // Cleanup au unmount de App (rare, mais propre)
    return () => {
      // On ne disconnect PAS ici car le user peut juste changer (refresh getCurrentUser)
      // Le disconnect est géré dans logoutUser
    };
  }, [user, user?.id]); //  seulement quand l'ID change (login/logout)

  return (
    <div className="main-wrapper">
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Nunito, sans-serif',
          },
        }}
      >
        <AllRoutes />
      </ConfigProvider>
    </div>
  );
};

export default App;